import { useOrganizationAccess } from 'hooks/useOrganizationAccess';
import React from 'react';
import {
    Link,
} from 'react-router-dom';
import {
    DropdownItem,
} from 'reactstrap';
import { TFeature, FEATURE_IDS } from 'services/constants';
import { NSBadge } from 'bricks';
import useAuthContext from 'contexts/AuthContext';
import { AccessLevels } from 'types/auth';
import FeatureTierPopover from '../FeatureTierPopOver/FeatureTierPopover';

export interface IProps {
    label: string,
    url: string
    feature?: TFeature
    toggleActivePopover: (feature: TFeature) => void
    activePopover: TFeature | null
    enterpriseRequired?: boolean
}

const NavMenuItem = ({
    label, url, feature, toggleActivePopover, activePopover, enterpriseRequired,
}: IProps) => {
    const setFeaturePopover = () => {
        if (toggleActivePopover && feature) { toggleActivePopover(feature); }
    };
    const isFeaturePopoverActive = (activePopover === feature);
    const { hasEnterpriseLicense } = useOrganizationAccess();
    const { isFeatureAccessibleToUser } = useAuthContext();

    const isDisabled = feature ? !isFeatureAccessibleToUser([FEATURE_IDS[feature]], AccessLevels.READ_ACCESS) : false;

    const upgradeTier = hasEnterpriseLicense || enterpriseRequired ? 'Enterprise' : 'Pro';

    return !isDisabled ? (
        <Link to={url}>
            <DropdownItem
                id={feature}
            >
                {label}
            </DropdownItem>

        </Link>

    ) : (
        <div
            role="button"
            onClick={setFeaturePopover}
            onKeyDown={setFeaturePopover}
            tabIndex={0}
        >
            <DropdownItem
                disabled
                id={feature}
            >
                {label}
                <NSBadge color="primary-lighten" className="ml-2">
                    {upgradeTier}
                </NSBadge>
            </DropdownItem>

            {(isFeaturePopoverActive && !!feature) && (
                <FeatureTierPopover
                    placement="bottom"
                    target={feature}
                    isOpen={isFeaturePopoverActive}
                    feature={feature}
                    toggle={setFeaturePopover}
                    upgradeTier={upgradeTier}
                />
            )}
        </div>
    );
};

export default NavMenuItem;
